import { render, staticRenderFns } from "./subMenuManage.vue?vue&type=template&id=49376f44&"
import script from "./subMenuManage.vue?vue&type=script&lang=js&"
export * from "./subMenuManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports